<template>
  <i class="fas fa-leaf fa-2x" style="font-size: 18px!important;"></i>
</template>

<script>
export default {};
</script>

<style>
</style>
